import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { postApiData } from "../helpers/AxiosInstance";
import { useNavigate } from "react-router-dom";
import { ParseError } from "../helpers/ParseError";

interface IUsePostHook {
  queryKey: string[];
  navigateURL?: string | null;
}

const usePostHook = ({ queryKey, navigateURL = null }: IUsePostHook) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { isPending, mutateAsync, isSuccess, data, isError } = useMutation({
    mutationFn: postApiData,
    onSuccess: async ({ data }) => {
      toast.success(data?.message ?? "Success");
      if (navigateURL) {
        navigate(navigateURL);
      }
    },
    onError: (error, variables) => {
      const { setError } = variables;
      if (setError) {
        //@ts-ignore
        for (const key in error?.response?.data) {
          //@ts-ignore
          if (error?.response?.data.hasOwnProperty(key)) {
            setError(key, {
              type: "custom",
              //@ts-ignore
              message: error.response?.data[key],
            });
          }
        }
      }
      throw error;
    },
    onSettled: async () => {
      queryClient.invalidateQueries({
        queryKey: queryKey,
        refetchType: "active",
      });
    },
  });

  return {
    isLoading: isPending,
    mutateAsync,
    isSuccess,
    data,
    isError,
  };
};

export default usePostHook;
